import {
  REQUEST_FOLLOW_USER, FAIL_FOLLOW_USER,
  REQUEST_UNFOLLOW_USER, FAIL_UNFOLLOW_USER,
  SET_USER_FOLLOW,
} from 'shared/actionTypes';

function buildFeedUserIdKeyFromAction(action) {
  const { feedUserType, feedUserRelatedId } = action.payload;
  return `${feedUserType}-${feedUserRelatedId}`;
}

export default function userFollows(state = {}, action) {
  let feedUserIdKey;

  switch (action.type) {
  case REQUEST_FOLLOW_USER:
  case FAIL_UNFOLLOW_USER:
    feedUserIdKey = buildFeedUserIdKeyFromAction(action);
    return Object.assign({}, state, {
      [feedUserIdKey]: true,
    });
  case REQUEST_UNFOLLOW_USER:
  case FAIL_FOLLOW_USER:
    feedUserIdKey = buildFeedUserIdKeyFromAction(action);
    return Object.assign({}, state, {
      [feedUserIdKey]: false,
    });
  case SET_USER_FOLLOW:
    feedUserIdKey = buildFeedUserIdKeyFromAction(action);
    const { isFollowing } = action.payload;
    return Object.assign({}, state, {
      [feedUserIdKey]: isFollowing,
    });
  default:
    return state;
  }
}
